import * as S from "./styles.ts";
import { ChevronLeft } from "@template/icons";
import { P } from "@template/components/typography";
import { ReactNode } from "react";
import UniversalLink from "@template/components/UniversalLink";

interface BreadcrumbItem {
  url?: string;
  label: string;
  ellipsis?: boolean;
  title?: string;
  icon?: ReactNode;
}

export interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbItem[];
  component?: ReactNode;
}

const Breadcrumbs = ({ breadcrumbs, component }: BreadcrumbsProps) => {
  return (
    <S.BreadcrumbWrapper>
      <S.BreadcrumbsContainer>
        <S.Breadcrumbs>
          {breadcrumbs.map((breadcrumb, index) => (
            <S.Breadcrumb
              key={index}
              $mobileShortcut={!!breadcrumb.ellipsis || !!breadcrumb.icon}
            >
              {breadcrumb.url ? (
                <UniversalLink
                  href={breadcrumb.url}
                  title={breadcrumb.title}
                >
                  <ChevronLeft />
                  <span>
                    {breadcrumb.ellipsis && "..."}
                    {breadcrumb.icon && breadcrumb.icon}
                  </span>
                  <P>{breadcrumb.label}</P>
                </UniversalLink>
              ) : (
                <div>
                  {" "}
                  <ChevronLeft />
                  <span>
                    {breadcrumb.ellipsis && "..."}
                    {breadcrumb.icon && breadcrumb.icon}
                  </span>
                  <P>{breadcrumb.label}</P>
                </div>
              )}
            </S.Breadcrumb>
          ))}
        </S.Breadcrumbs>
        {!!component && (
          <S.BreadcrumbComponent>{component}</S.BreadcrumbComponent>
        )}
      </S.BreadcrumbsContainer>
    </S.BreadcrumbWrapper>
  );
};

export default Breadcrumbs;
